// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__V9xt0","vLegacy":"SelectSecondary_vLegacy__2MpuE","error":"SelectSecondary_error__3UeHa","disabled":"SelectSecondary_disabled__3IM68"};